module.exports = __webpack_public_path__ + "img/star.8ddb7043.svg";